import React, { CSSProperties, FC, useState } from "react";
import "./PlayerControls.scss";

type PlayerControlsType = {
  isMobile: boolean;
  videoProgress: number;
  volume: number;
  videoDuration: number;
  isPlaying: boolean;
  onPause: Function;
  onChangeVolume: Function;
  onSetCurrentProgress: Function;
};

const PlayerControls: FC<PlayerControlsType> = (props) => {
  const {
    isMobile,
    videoProgress,
    volume,
    videoDuration,
    isPlaying,
    onPause,
    onChangeVolume,
    onSetCurrentProgress,
  } = props;
  const [progressBarFromLeft, setProgressBarFromLeft] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const volumeBars = [1, 2, 3, 4];
  const volumePerBar = 1 / volumeBars.length;
  const barStyles = {
    "--video-width": `${videoProgress}%`,
  } as CSSProperties;

  const getVolumeStatusClass = (index) => {
    const currentVolumeIndex = volume / volumePerBar;
    return index <= currentVolumeIndex ? "is-active" : "";
  };

  function getProgressBarScreenXPosition(event) {
    const menuWidth =
      window.innerWidth - event.target.parentElement.offsetWidth;
    const barFromMenu = event.target.offsetLeft;
    const elFromLeft = menuWidth + barFromMenu;
    setProgressBarFromLeft(elFromLeft);

    return elFromLeft;
  }

  const onCurrentProgressChange = (event, pointerPositionX) => {
    let barFromLeft = progressBarFromLeft;

    if (!progressBarFromLeft) {
      barFromLeft = getProgressBarScreenXPosition(event);
    }

    const barWidth = event.target.clientWidth;
    const positionX = pointerPositionX - barFromLeft;
    const newProgressPercentage = positionX / barWidth;
    const newProgressSeconds = newProgressPercentage * videoDuration;

    onSetCurrentProgress(newProgressSeconds);
  };

  const onDragProgressBar = (event, isMobileActive) => {
    if (!isDragging) {
      return;
    }
    const positionX = isMobileActive ? event.touches[0].clientX : event.clientX;
    onCurrentProgressChange(event, positionX)
  };

  return (
    <div className="player-controls">
      <button
        className={`player-controls__play-button ${
          !isPlaying ? "is-hidden" : ""
        }`}
        onClick={() => onPause(!isPlaying)}
      >
        <div
          className={`player-controls__${isPlaying ? "pause" : "play"}-icon`}
        />
      </button>
      <div
        className="player-controls__progress-bar"
        style={barStyles}
        onClick={(event) => onCurrentProgressChange(event, event.clientX)}
        onPointerDown={() => setIsDragging(true)}
        onPointerMove={(event) => !isMobile && onDragProgressBar(event, isMobile)}
        onPointerUp={() => setIsDragging(false)}
        onTouchMove={(event) => isMobile && onDragProgressBar(event, isMobile)}
      />
      <div className="player-controls__row">
        {volumeBars.map((i, index) => (
          <div
            className={`player-controls__volume-bar ${getVolumeStatusClass(
              index + 1
            )}`}
            key={`bar-${index}`}
            tabIndex={0}
            onClick={() => onChangeVolume(volumePerBar * (index + 1))}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default PlayerControls;
